import { WorkReportStatus } from '../form/work-report-status.enum';
import { ProjectItemType } from '../project/project-item-type.enum';
import { ProjectSectionUnitJgStatus } from './project-section-unit-jg-status.enum';

export class JgPhysicalInspUnitItemInfo {
  [x: string]: any;
  id?: number;
  projectId?: number;
  jgSectionId?: number;
  sectionId?: number;
  dwTypeName?: string;
  dwTypeNameSort?: number;
  dwCode?: string;
  dwCodeSort?: number;
  dwName?: string;
  jgFbName?: string;
  jgFbNameSort?: number;
  jgFxName?: string;
  jgFxProjectTypeCode?: string;
  jgFxProjectTypeName?: string;
  sectionItemId?: number;
  type?: ProjectItemType;
  jgInspItemCode?: string;
  jgInspItemName?: string;
  jgInspItemCodeSort?: number;
  jgRfiFormId?: number;
  jgRfiId?: number;
  jgRfiStatus?: WorkReportStatus;
  jgRfiName?: string;
  jgRfiWorkFlowKey?: string;
  jgHirId?: number;
  jgHirName?: string;
  jgHirWorkFlowKey?: string;
  status?: ProjectSectionUnitJgStatus;
  sectionItemNum?: number;
  sectionItemSummary?: string;
  inRecycleBin?: boolean;
  comment?: string;
  // 前端自用
  checked?: boolean;
}
